// export function getFullUrl(url) {
//     if (!url || url === '') {
//         return "";
//     } else {
//         return `${process.env.VUE_APP_API_TARGET}/hy/schemeMaterial/show${url}`;
//     }
// }

export function getFullUrl(url) {
    if (!url || url === '') {
        return "";
    } else {
        return `${process.env.VUE_APP_API_MINIO_URL}${url}`;
    }
}